import { getContentType } from 'shared/lib'
import { getExtension } from 'shared/lib/getExtension'
import type { IUploadInfoKeys } from '../store/type'

export const getFileType = async (file: File): Promise<IUploadInfoKeys> => {
  if (file.type && file.type !== '' && file.type !== 'application/octet-stream') {
    if (file.type.includes('audio')) return 'audio'
    if (file.type.includes('video')) return 'video'
    if (file.type.includes('vcard')) return 'vcard'
    if (file.type.includes('image')) return 'image'
    if (file.type.includes('application') || file.type.includes('text')) return 'docs'
  }

  const extension = getExtension(file.name)
  const typeFromExtension = getFileTypeFromExtension(extension)
  if (typeFromExtension) {
    return typeFromExtension
  }

  const key = await getContentType(file)
  return getFileTypeFromMimeType(key)
}

const getFileTypeFromExtension = (extension: string): IUploadInfoKeys | null => {
  const imageExtensions = ['jpg', 'jpeg', 'png', 'gif', 'heic', 'heif']
  const videoExtensions = ['mp4', 'mov']
  const audioExtensions = ['mp3', 'wav', 'aac', 'm4a', 'ogg']
  const docExtensions = ['pdf', 'doc', 'docx', 'xls', 'xlsx', 'csv', 'txt']
  const vcardExtensions = ['vcf', 'vcard']

  if (imageExtensions.includes(extension)) return 'image'
  if (videoExtensions.includes(extension)) return 'video'
  if (audioExtensions.includes(extension)) return 'audio'
  if (docExtensions.includes(extension)) return 'docs'
  if (vcardExtensions.includes(extension)) return 'vcard'

  return null
}

const getFileTypeFromMimeType = (mimeType: string): IUploadInfoKeys => {
  if (!mimeType || mimeType === 'unsupported' || mimeType === '') {
    return 'default'
  }

  if (mimeType.includes('audio')) return 'audio'
  if (mimeType.includes('video')) return 'video'
  if (mimeType.includes('vcard')) return 'vcard'
  if (mimeType.includes('image')) return 'image'
  if (mimeType.includes('application') || mimeType.includes('text')) return 'docs'

  return 'default'
}
